import { useState } from "react";
import { useAuth } from "../lib/auth.tsx";

export default function Login() {
  const { hasOwner, login, register } = useAuth();
  const isRegister = !hasOwner;
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      if (isRegister) await register(email, name || "Owner", password);
      else await login(email, password);
    } catch (e: any) {
      const code = e?.code || e?.message;
      setErr(
        code === "invalid_credentials" ? "อีเมลหรือรหัสผ่านไม่ถูกต้อง" :
        code === "invalid_input" ? "กรุณากรอกข้อมูลให้ครบ (รหัสผ่านอย่างน้อย 6 ตัว)" :
        "เกิดข้อผิดพลาด ลองใหม่อีกครั้ง"
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-wrap">
      <form className="auth-card" onSubmit={submit}>
        <div className="auth-logo">
          <div className="sidebar__logo" style={{ width: 44, height: 44 }}>MH</div>
          <div>
            <div style={{ fontWeight: 800, fontSize: 19, fontFamily: "var(--font-en)" }}>MARKETING Hero</div>
            <div className="mh-sec" style={{ fontSize: 13 }}>Sooksabay AI Marketing Advisor</div>
          </div>
        </div>

        <h1 style={{ fontSize: 20, marginBottom: 4 }}>
          {isRegister ? "ตั้งค่าบัญชี Owner ครั้งแรก" : "เข้าสู่ระบบ"}
        </h1>
        <p className="mh-sec" style={{ fontSize: 14, marginBottom: 20 }}>
          {isRegister ? "สร้างบัญชีผู้ดูแลระบบเพื่อเริ่มใช้งาน" : "ยินดีต้อนรับกลับมา"}
        </p>

        {isRegister && (
          <div className="mh-field">
            <label className="mh-label">ชื่อ</label>
            <input className="mh-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="เช่น อาจารย์แม็ค" />
          </div>
        )}
        <div className="mh-field">
          <label className="mh-label">อีเมล</label>
          <input className="mh-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@sooksabay.com" />
        </div>
        <div className="mh-field">
          <label className="mh-label">รหัสผ่าน</label>
          <input className="mh-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder={isRegister ? "อย่างน้อย 6 ตัวอักษร" : "••••••••"} />
        </div>

        {err && <div className="mh-pill mh-pill--problem" style={{ marginBottom: 14 }}>{err}</div>}

        <button className="mh-btn mh-btn--primary mh-btn--lg" style={{ width: "100%" }} disabled={busy}>
          {busy ? <span className="spinner" /> : isRegister ? "สร้างบัญชี & เริ่มใช้งาน" : "เข้าสู่ระบบ"}
        </button>
      </form>
    </div>
  );
}
